import React from "react";
import { motion } from "framer-motion";

function BlockLeftImage(props) {
  return (
<div className="max-w-6xl m-auto py-6 px-6 sm:px-0  ">
      
      {/* Contenedor principal en Grid optimizado para evitar desbordamientos */}
      <div className="grid grid-cols-1 md:grid-cols-2 w-full max-w-7xl mx-auto items-center gap-8 md:gap-12">
        
        {/* Columna de Imagen */}
        <motion.div 
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="w-full flex justify-center"
        >
          <img 
            src={props.src} 
            alt={props.alt} 
            className="w-full max-w-md md:max-w-full h-auto object-cover rounded-2xl shadow-md" 
          />
        </motion.div>

        {/* Columna de Texto con control de desbordamiento (break-words) */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          className="w-full max-w-xl mx-auto md:mx-0 break-words [&_a]:inline-block [&_a]:bg-[#febe10] [&_a]:px-5 [&_a]:py-2.5 [&_a]:max-w-max [&_a]:rounded [&_a]:text-[10pt] [&_a]:font-bold [&_a]:no-underline [&_a]:text-[#004270] hover:[&_a]:bg-[#fcc755] hover:[&_a]:text-white [&_a]:transition-colors"
        >
          {props.content}
        </motion.div>

      </div>
    </div>
  );
}

export default BlockLeftImage;